module.exports = __webpack_public_path__ + "img/Frame 7@2x.4a9cc097.png";